import { render, staticRenderFns } from "./ValidatedForm.vue?vue&type=template&id=eb48a730"
import script from "./ValidatedForm.vue?vue&type=script&lang=js"
export * from "./ValidatedForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports